export enum DeviceConferenceOperationMode {
	Conference = 'CONFERENCE',
	Presentation = 'PRESENTATION',
	Direct = 'DIRECT',
	Custom = 'CUSTOM'
}
